// extracted by mini-css-extract-plugin
export default {"summary":"ProductsSummary_summary__OqT8v"};